// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".send-request-tab .resident-info[data-v-b7911438]{background-color:#fff;border:1px solid #ccc;border-radius:.5rem;width:800px;min-width:800px;max-width:800px}.send-request-tab .cancel-btn[data-v-b7911438],.send-request-tab .send-message-btn[data-v-b7911438]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
